export function abbreviateNumber(value: number, locale = 'en-US') {
  return Intl.NumberFormat(locale, {
    notation: 'compact',
    style: 'decimal',
    maximumFractionDigits: 1
  }).format(value)
}

// pick format from user's locale
const formatter = new Intl.NumberFormat(undefined, {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
})

export function amountFormatForUserLocale(value: string | number) {
  return value === '' ? 0 : formatter.format(Number(typeof value === 'number' ? value : Number.parseFloat(value)))
}
